<template>
  <div id="app">
    <div v-if="showView&&isTenantId" class="app-wrap">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <bottombar v-if="!isWap&&isTenantId" />
  </div>
</template>

<script>
import bottombar from './components/BottomBar.vue'
import { isMobile, isWeiXin } from './utils/utils.js'
import config from './utils/config.js'
import api from './api/auth.js'
import homeapi from './api/home.js'
import auth from './models/auth.js'
import user from './models/user.js'
import { getQueryString } from './utils/utils.js'
// import common from './api/common.js'

export default {
  name: 'App',
  components: {
    bottombar
  },
  data() {
    return {
      isWap: false,
      showView: true,
      isTenantId:false
    }
  },
  created() {
    this.$store.dispatch('navigation/setNavigatorIndex', 1)
    if (isMobile() || isWeiXin()) {
      config.planform = 'wap'
      this.isWap = true
    }
    this.getHomeTenant();
    this.setRem()
    this.requestUser()
    this.requestCommonData()
  },
  mounted(){
    
    console.log('初始化')
  },
  methods: {
    //获取应用信息
    requestclient() {
      console.log('this.$store123123')
      const that = this
      homeapi.requestclient({ tenantId: this.$store.getters.tenantId }).then(res => {
         this.$store.commit('user/APP_LICATION',res.data)
          console.log('this.store',this.$store)

      }).catch(err => {
        console.log(err)
      })
    },
   
    //获取租户信息
    getHomeTenant() {
      console.log('window.location.hostname',window.location.hostname)
      let hostname = window.location.hostname;
      let tenantIdStr = hostname.split('.')[0];
     
      // console.log('tenantIdStr',tenantIdStr.toUpperCase())
      // this.$store.commit('user/SET_TENANTID','ADKS')
      // this.isTenantId = true;
      // this.requestclient();
      // const that = this;
      if(hostname == '39.105.189.43'){
        tenantIdStr = 'DXKJ'
      }
      api.homeTenant({ tenantId:tenantIdStr?tenantIdStr.toUpperCase():'ADKS' }).then(res => {
        if(res.code==200){
          this.$store.commit('user/SET_TENANTID',res.data.tenantId)
          this.isTenantId = true;
          this.requestclient();
         
        }
      }).catch(err => {
         this.isWap = true
          this.$router.push('/404')
        console.log(err)
      })     
    },
    handleRouter() {
      console.log(document.location.href)
      const href = document.location.href
      if (href.indexOf('?code=') >= 0) {
        if (href.indexOf('/user') >= 0) {
          const code = getQueryString('code')
          this.$router.replace({
            path: '/user',
            query: {
              code: code
            }
          })
        } else if (href.indexOf('/login') >= 0) {
          const code = getQueryString('code')
          this.$router.replace({
            path: '/login',
            query: {
              code: code
            }
          })
        }
      }
    },
    // 设置rem
    setRem() {
      /* 设计图文档宽度 */
      var docWidth = 1080
      var doc = window.document
      var docEl = doc.documentElement
      var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
      var recalc = (function refreshRem() {
      /* 窗口当前宽度 */
        var clientWidth = window.innerWidth
        /* 页面宽度大于 设计图文档宽度 时不再放大 */
        clientWidth = clientWidth > docWidth ? docWidth : clientWidth
        var oldSize = (clientWidth / docWidth * 100) + 'px'
        docEl.style.fontSize = oldSize

        /* 获取设置后的字体大小情况 - 因微信设置APP字体大小后会影响该设置 */
        var nowSize = window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize
        var oldSizeValue = parseFloat(oldSize, 10)
        var nowSizeValue = parseFloat(nowSize, 10)

        /* 当差值大于1时重新按差比计算出正确的px值 */
        if ((nowSizeValue - oldSizeValue) > 1 || (nowSizeValue - oldSizeValue) < -1) {
          var diff = (oldSizeValue / nowSizeValue)
          docEl.style.fontSize = (clientWidth / docWidth * 100 * diff) + 'px'
        }
        return refreshRem
      })()
      /* 添加倍屏标识，安卓为1 */
      docEl.setAttribute('data-dpr', window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1)
      if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
      /* 添加IOS标识 */
        doc.documentElement.classList.add('ios')
        /* IOS8以上给html添加hairline样式，以便特殊处理 */
        if (parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8) { doc.documentElement.classList.add('hairline') }
      }
      if (!doc.addEventListener) return
      window.addEventListener(resizeEvt, recalc, false)
      doc.addEventListener('DOMContentLoaded', recalc, false)
    },
    requestUser() {
      if (auth.gettoken()) {
        if (user.getUserData()) {
          // 用户信息存在 不再重新请求 如果token过期会在服务器返回401时清除token和用户信息
          this.showView = true
        } else {
          const that = this
          api.userInfo().then(r => {
            that.showView = true
            user.save(r.data)
          })
        }
      } else {
        this.showView = true
      }
    },
    requestCommonData() {
      // 请求常量数据保存到本地
      // auth.clean()
    }
  }
}
</script>

<style>
html {
  height: 100%;
}
body {
  height: 100%;
  font-size: 0;
}

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.app-wrap {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dplayer-notice{
  display: none;
}

</style>
